import { Button, Flex, Modal, Typography } from "antd";

interface IPilotUpload {
  isModalOpen: boolean;
  handleCancel: () => void;
}

export function DocstoreSectionPilotUpload({
  isModalOpen,
  handleCancel,
}: IPilotUpload) {
  return (
    <Modal
      title="Загрузка из PILOT"
      open={isModalOpen}
      onCancel={handleCancel}
      footer={
        <Flex justify="start" gap="middle">
          <Button type="primary">Загрузить</Button>
          <Button onClick={handleCancel}>Отмена</Button>
        </Flex>
      }
      style={{ minWidth: "720px", padding: "24px 32px" }}
    >
      <Flex gap="middle" vertical>
        <Typography.Text>
          Выберите необходимые документы и нажмите Загрузить
        </Typography.Text>

        <Flex
          style={{
            width: "100%",
            height: "290px",
            border: "1px solid #DDDDDD",
            backgroundColor: "#F5F5F5",
          }}
          align="center"
          justify="center"
        >
          <Typography.Text>Документы из PILOT</Typography.Text>
        </Flex>
      </Flex>
    </Modal>
  );
}
